import { Table } from "react-bootstrap";
import MapProduct from "../../../utils/ProductMapper/MapProduct";

export default function InvoiceTable(props) {
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const sortedData = props.Data.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );

    const formatRemainingDays = (expiryDate) => {
        const currentDate = new Date();
        const expiry = new Date(expiryDate);

        if (expiry < currentDate) {
            return "Expired";
        }

        let years = expiry.getFullYear() - currentDate.getFullYear();
        let months = expiry.getMonth() - currentDate.getMonth();
        let days = expiry.getDate() - currentDate.getDate();

        if (days < 0) {
            months -= 1;
            const previousMonth = new Date(expiry.getFullYear(), expiry.getMonth(), 0);
            days += previousMonth.getDate();
        }

        if (months < 0) {
            years -= 1;
            months += 12;
        }

        let remainingText = "";
        if (years > 0) {
            remainingText += `${years} year${years > 1 ? "s" : ""} `;
        }
        if (months > 0) {
            remainingText += `${months} month${months > 1 ? "s" : ""} `;
        }
        if (days > 0) {
            remainingText += `${days} day${days > 1 ? "s" : ""}`;
        }

        return remainingText.trim();
    };

    const getRemainingDaysStyle = (expiryDate) => {
        const currentDate = new Date();
        const expiry = new Date(expiryDate);
        const timeDiff = expiry - currentDate;

        if (timeDiff <= 0) {
            return {
                color: "grey",
                fontWeight: "bold",
            };
        } else if (timeDiff / (1000 * 60 * 60 * 24) <= 30) {
            return {
                color: "red",
                fontWeight: "bold",
            };
        }

        return {};
    };

    return (
        <div className="invoice-table-container">
            <Table className="mt-4 redesign-table">
                <thead>
                    <tr>
                        <th scope="col" className="text-left">SR.</th>
                        <th scope="col" className="text-left">LICENSE ID</th>
                        <th scope="col" className="text-left">PRODUCT</th>
                        <th scope="col" className="text-left">ACTIVATION</th>
                        <th scope="col" className="text-left">VALID UPTO</th>
                        <th scope="col" className="text-left">STATUS / REMAINING</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedData.map((item, index) => {
                        const statusText = formatRemainingDays(item.expires_at);
                        const isExpired = statusText === "Expired";

                        return (
                            <tr key={index} style={{ pageBreakInside: 'avoid' }}>
                                <td className="text-left">{index + 1}</td>
                                <td className="text-left license-id-cell">{item.license_ref_id}</td>
                                <td className="">{MapProduct(item.product)}</td>
                                <td className="text-left">{formatDate(item.created_at)}</td>
                                <td className="text-left">{formatDate(item.expires_at)}</td>
                                <td className="text-left">
                                    <span className={`status-pill ${isExpired ? 'expired' : 'active'}`}>
                                        {statusText}
                                        {!isExpired && getRemainingDaysStyle(item.expires_at).color === "red" && ` Left`}
                                    </span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
}
